import React, { useEffect } from "react";
import { Switch, Redirect } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import ResetPassword from "./ResetPassword";
import { useState } from "react";
import { Grid, Form, Dropdown } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import { selectTranslations, setLang } from "../../../config/i18n/slice";
import CreatePassword from "./CreatePassword";
import { useLocation } from "react-router";
import packageJson from "../../../../../package.json";
import { setCookie } from "../../../config/common/commonFunctions";

export function AuthPage() {
  const dispatch = useDispatch();

  const curentUrl = useLocation();
  const queryParams = new URLSearchParams(curentUrl.search);
  const language = queryParams.get("language");

  const lang = useSelector((state) => state.i18n.lang);
  const supportedLangs = useSelector((state) => state.i18n.supportedLangs);
  const t = useSelector(selectTranslations);

  const [dropdownOptions, setDropdownOptions] = useState({
    lang: Object.entries(supportedLangs).map(([code, name]) => {
      return {
        key: code,
        value: code,
        text: name,
      };
    }),
  });

  const handleLanguageChange = (lang) => {
    dispatch(setLang(lang));
    setCookie("LANG", lang, 10);
  };
  useEffect(() => {
    if (language) {
      handleLanguageChange(language === "Arabic" ? "ar" : "en");
    }
  }, [language]);

  return (
    <>
      <div
        className={`d-flex flex-column flex-root ${
          lang == "ar" ? "direction-rtl" : ""
        }`}
      >
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white scroll-width"
          id="kt_login"
        >
          <div
            className="login-aside d-none  d-lg-flex  bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={
              lang == "en"
                ? {
                    backgroundImage: `url(${toAbsoluteUrl(
                      "/media/bg/bg-color.svg"
                    )})`,
                    borderRadius: "0px 60px 60px 0px",
                  }
                : {
                    borderRadius: "60px 0px 0px 60px",
                    backgroundImage: `url(${toAbsoluteUrl(
                      "/media/bg/bg-arabic.svg"
                    )})`,
                  }
            }
          >
            <div className="d-flex flex-row-fluid flex-column justify-content-between login-container">
              <div className="mt-29">
                <h3 className="b1-font-size app-title mb-5 text-black">
                  {t.auth.title}
                </h3>
                <p className="font-weight-normal app-subTitle opacity-80">
                  {t.auth.subtitle}
                </p>
              </div>

              <div className="app-image flex-column-fluid d-flex flex-column justify-content-center login-text">
                <img
                  className="mt-18 image-responsive"
                  alt="Logo"
                  src={toAbsoluteUrl("/media/bg/bg-home.svg")}
                />
              </div>

              <div className="d-none flex-column-auto d-lg-flex justify-content-between">
                <div className="opacity-70 copy-right-text font-weight-bold	text-black">
                  {t.auth.copyright} &copy; {new Date().getFullYear()}{" "}
                  {t.auth.quiqflow}
                  <br />
                  {t.auth.all_rights_reserved}
                  <br /> {packageJson?.webappversion}
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-row-fluid position-relative p-7">
            <div className="d-flex justify-content-end mt-5">
              <Grid columns="equal">
                <Grid.Column>
                  <Form.Field>
                    <label>{t.common.language}</label>
                    <Dropdown
                      fluid
                      selection
                      options={dropdownOptions.lang}
                      value={lang}
                      className="lang-dropdown"
                      placeholder="Select Language"
                      onChange={(event, value) => {
                        handleLanguageChange(value.value);
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid>
            </div>

            <div className="d-flex flex-column-fluid justify-content-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path="/auth/login" component={Login} />
                <ContentRoute
                  path="/auth/forgot-password"
                  component={ForgotPassword}
                />
                <ContentRoute
                  path="/auth/reset-password"
                  component={ResetPassword}
                />
                <ContentRoute
                  path="/auth/create-password"
                  component={CreatePassword}
                />
                <Redirect from="/auth" exact={true} to="/auth/login" />
                <Redirect to="/auth/login" />
              </Switch>
            </div>

            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between  mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; {t.auth.copyright} &copy; {new Date().getFullYear()}{" "}
                {t.auth.quiqflow} <br />
                {t.auth.all_rights_reserved}
                <br /> {packageJson?.webappversion}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
